import { ITaxes, taxes as defaultTaxes } from '@betgames/bg-tools';
import { ICurrency } from 'interfaces/ICurrency';
import { getTaxSettingsBySchemeId } from './utils/getTaxSettingsBySchemeId';

export class Taxes {
    private taxSchema = defaultTaxes;

    public configure(taxes: ITaxes, currency: ICurrency): void {
        this.taxSchema = getTaxSettingsBySchemeId(taxes.schemeId);
        this.taxSchema.configure(taxes, currency);
    }

    public get schema() {
        return this.taxSchema;
    }
}
